export default __webpack_public_path__ + "static/media/main-title.9c2d37aa.png";